<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider #default="validationContext" name="token" rules="required">
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.profile')"
              :label-for="`token`"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="selectedStream.token"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="currentStreamsOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="token"
                @input="(val) => changeProfile(val)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('camera_proxy.encoding')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.encoding')"
              label-for="encoding"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="selectedStream.encoding"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="videoEncoderOptions"
                :clearable="false"
                input-id="encoding"
                @input="(val) => updateSettings()"

              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mx-0">
        
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="resolution"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.resolution')"
              label-for="resolution"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="selectedStream.resolution"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="resolutionOptions"
                :clearable="false"
                input-id="resolution"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('camera_proxy.gov')"
            rules="required"
          >
            <b-form-group
              :label="`${$t('camera_proxy.gov')} ${govRange.min} - ${
                govRange.max
              }`"
              label-for="name"
            >
              <b-form-input
                id="quality"
                v-model="selectedStream.gov_length"
                :placeholder="$t('camera_proxy.gov')"
                :state="getValidationState(validationContext)"
                type="number"
                step="1"
                :min="govRange.min"
                :max="govRange.max"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="frame_rate"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.frame_rate')"
              label-for="frame_rate"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="selectedStream.frame_rate"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="frameRateOptions"
                :clearable="false"
                input-id="frame_rate"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <!-- bitrate -->
          <validation-provider
            #default="validationContext"
            :name="$t('camera_proxy.bitrate')"
            rules="required"
          >
            <b-form-group
              :label="`${$t('camera_proxy.bitrate')} ${bitrateRange.min} - ${
                bitrateRange.max
              }`"
              label-for="name"
            >
              <b-form-input
                id="quality"
                v-model="selectedStream.bitrate"
                :placeholder="$t('camera_proxy.bitrate')"
                :state="getValidationState(validationContext)"
                type="number"
                step="1"
                :min="bitrateRange.min"
                :max="bitrateRange.max"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider :name="$t('camera_proxy.vbr')" rules="required">
            <b-form-checkbox
              id="vbr"
              v-model="selectedStream.cbr"
              name="vbr"
              :value="false"
              :unchecked-value="true"
              class="my-1 text-capitalize"
              switch
            >
              {{ $t("camera_proxy.vbr") }}
            </b-form-checkbox>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <!-- quality -->
          <validation-provider
            #default="validationContext"
            :name="$t('camera_proxy.quality')"
            rules="required"
          >
            <b-form-group
              :label="`${$t('camera_proxy.quality')} ${qualityRange.min} - ${
                qualityRange.max
              }`"
              label-for="name"
            >
              <b-form-input
                id="quality"
                v-model="selectedStream.quality"
                :placeholder="$t('camera_proxy.quality')"
                :state="getValidationState(validationContext)"
                type="number"
                step="1"
                :min="qualityRange.min"
                :max="qualityRange.max"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
// Resto de las importaciones
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from "axios";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, {emit}) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));
    const resolutionOptions = ref([]);
    const frameRateOptions = ref([]);
    const videoEncoderOptions = ref([]);
    const bitrateRange = ref({
      min: 0,
      max: 0,
    });
    const qualityRange = ref({
      min: 0,
      max: 0,
    });

    const govRange = ref({
      min: 0,
      max: 0,
    });

    let cameraData = {
      camera_ip: itemData.value.data.onvif_host,
      camera_port: itemData.value.data.onvif_port,
      camera_user: itemData.value.data.user,
      camera_pass: itemData.value.data.password,
    };

    const selectedStream = ref({
      bitrate: 0,
      cbr: false,
      encoding: "",
      frame_rate: 0,
      gov_length: 0,
      quality: 0,
      resolution: "0x0",
      token: "",
      profile_name: "",
    });

    const currentStreams = ref(null);
    const currentStreamsOptions = ref([]);
    const availableStreams = ref(null);

    try {
      axios
        .post(`${window.__env.VUE_APP_ONVIF_URL}/video-config`, {
          ...cameraData,
        })
        .then(({ data }) => {
          currentStreams.value = data;

          selectedStream.value = JSON.parse(JSON.stringify(currentStreams.value[0]));
          selectedStream.value.resolution = `${currentStreams.value[0].resolution.width}x${currentStreams.value[0].resolution.height}`;

          currentStreamsOptions.value = currentStreams.value.map((stream) => {
            return { label: stream.profile_name, value: stream.token };
          });

          try {
            axios
              .post(`${window.__env.VUE_APP_ONVIF_URL}/available-video-config`, {
                ...cameraData,
              })
              .then(({ data }) => {
                availableStreams.value = data;
                updateSettings();
              });
          } catch (error) {}
        });
    } catch (error) {}

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const trans = {
      "messages.edit_save.updated_successfully": t("messages.edit_save.updated_successfully"),
      "messages.errors.general": t("messages.errors.general"),
    };

    const saveChanges = () => {
      let resolutionSplit = selectedStream.value.resolution.split('x')
      axios
        .post(`${window.__env.VUE_APP_ONVIF_URL}/update-video-config`, {
          ...cameraData,
          ...selectedStream.value,
          resolution: {
            width: resolutionSplit[0],
            height: resolutionSplit[1]
          }
        })
        .then(({ data }) => {
          emit("content-toast", trans["messages.edit_save.updated_successfully"], "success")
        }).catch(({ data }) => {
          emit("content-toast", trans["messages.errors.general"], "danger")
        })
    };

    const changeProfile = (token) => {
      let selectedStream1 = currentStreams.value.find((st) => token == st.token);

      selectedStream.value = selectedStream1;
      selectedStream.value.resolution = `${selectedStream1.resolution.width}x${selectedStream1.resolution.height}`;

      updateSettings();
    };

    const updateSettings = () => {
      let availableStream = availableStreams.value.find(
        (stream) => stream.token == selectedStream.value.token
      );

      let streamOptions = availableStream.video_encoder_configurations.find(
        (stream) => stream.encoding == selectedStream.value.encoding
      );

      resolutionOptions.value = streamOptions.resolutions_available.map(
        (resolution) => `${resolution.width}x${resolution.height}`
      );

      frameRateOptions.value = streamOptions.frame_rates_supported;
      bitrateRange.value = streamOptions.bitrate_range;
      qualityRange.value = streamOptions.quality_range;
      govRange.value.min = streamOptions.gov_length_range[0];
      govRange.value.max = streamOptions.gov_length_range[1];
      
      videoEncoderOptions.value = availableStream.video_encoder_configurations.map(
        (stream) => `${stream.encoding}`
      );
    };

    return {
      refFormObserver,
      getValidationState,
      validateStep,
      saveChanges,
      selectedStream,
      currentStreams,
      availableStreams,

      currentStreamsOptions,
      resolutionOptions,
      frameRateOptions,
      videoEncoderOptions,
      bitrateRange,
      qualityRange,
      govRange,

      changeProfile,
      updateSettings,
    };
  },
};
</script>
